export default "__VITE_ASSET__Bdfa8mg3__"